<template>
  <div class="navbar-container h-100 d-flex flex-column bg-transparent">
    <div class="navbar-layout flex-row flex-xl-column">
      <div class="text-center">
        <router-link
          class="nav-link d-flex flex-column align-items-center justify-content-center"
          to="/home"
        >
          <div class="icon-container rounded-2 p-2 mb-1">
            <img
              src="@/assets/img/home_icon.svg"
              alt="Home Icon"
              width="25"
              height="24"
            >
          </div>
          <span class="small text-muted">{{ $t('menu.home') }}</span>
        </router-link>
      </div>

      <feature name="plans">
        <div class="text-center">
          <router-link
            class="nav-link d-flex flex-column align-items-center justify-content-center"
            to="/plans"
          >
            <div class="icon-container rounded-2 p-2 mb-1">
              <img
                src="@/assets/img/plans_icon.svg"
                alt="Plans Icon"
                width="24"
                height="24"
              >
            </div>
            <span class="small text-muted">{{ $t('menu.plans') }}</span>
          </router-link>
        </div>
      </feature>

      <div class="text-center">
        <router-link
          class="nav-link d-flex flex-column align-items-center justify-content-center"
          to="/settings"
        >
          <div class="icon-container rounded-2 p-2 mb-1">
            <img
              src="@/assets/img/settings_icon.svg"
              alt="Settings Icon"
              width="24"
              height="24"
            >
          </div>
          <span class="small text-muted">{{ $t('menu.settings') }}</span>
        </router-link>
      </div>

      <div
        v-if="authStore.isAdmin"
        class="text-center"
      >
        <router-link
          class="nav-link d-flex flex-column align-items-center justify-content-center"
          to="/admin"
        >
          <div class="icon-container rounded-2 p-2 mb-1">
            <img
              src="@/assets/img/admin_icon.svg"
              alt="Admin Icon"
              width="24"
              height="24"
            >
          </div>
          <span class="small text-muted">{{ $t('menu.admin') }}</span>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import feature from 'vue-feature-toggle';
import { useAuthStore } from '@/stores/authStore';

export default defineComponent({
  name: 'NavBarComponent',
  components: {
    feature,
  },
  setup() {
    const authStore = useAuthStore();

    return {
      authStore,
    };
  },
});
</script>

<style lang="scss">
.navbar-container {
  width: 250px;
  position: relative;
  background-color: #fff;
  border-right: 1px solid #E0E3E5;
  padding-top: 2rem;

  @media (min-width: 1199.98px) {
    width: 91px;    
  }
}

.navbar-layout {
  display: flex;
  height: 100%;
}

.nav-link {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem 0;

  .icon-container {
    margin-bottom: 0.5rem;
  }

  span {
    font-size: 0.8rem;
    color: #6c757d;
  }
}

@media (max-width: 1199.98px) {
  .navbar-container {
    position: static;
    width: 100%;
    border-right: none;
    border-top:1px solid #E0E3E5;
    padding:0;
  }

  .navbar-layout {
    justify-content: space-around;
  }
}

.nav-link {
  text-decoration: none !important;
}

.router-link-active .icon-container {
  background: #f2f5f8;
}

.router-link-active span {
  font-weight: 700;
}

.nav-link:hover .icon-container {
  background: #f2f5f8;
}

.nav-link:hover span {
  font-weight: 700;
}
</style>